import "./VpnReviews.module.css";
import Header from "@/reusable_sections/Header";
import VpnRankingsHero from "./sections/VpnRankingsHero";
import Vpnreviewbloggrid from "./sections/Vpnreviewbloggrid";
import Footer from "@/reusable_sections/Footer";
export default function VpnReviewsPage() {
  return <div>
      <Header />
      <VpnRankingsHero />
      <Vpnreviewbloggrid />
      <Footer />
    </div>;
}